import { render, staticRenderFns } from "./AbilitateAttivita.vue?vue&type=template&id=434b0d70&"
import script from "./AbilitateAttivita.vue?vue&type=script&lang=js&"
export * from "./AbilitateAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports